import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ApplicationInsightsService } from 'src/app/application-insights.service';
import { AgGridObject } from 'src/app/manage/types';
import { ManageTeamService } from '../services/manage-team/manage-team.service';

@Component({
  selector: 'app-edit-member-dialog',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-member-dialog.component.html',
  styleUrl: './edit-member-dialog.component.scss',
})
export class EditMemberDialogComponent implements ICellRendererAngularComp {
  @Input() passedParams: any;

  params: any;

  modalModel: AgGridObject;

  hideUpdateSpinner: boolean = true;
  updateResponse: string = '';
  updateSent: boolean = false;

  constructor(
    private modalService: NgbModal,
    private http: HttpClient,
    private _manageTeamService: ManageTeamService,
    private _applicationInsightsService: ApplicationInsightsService,
  ) {}

  get effectiveParams() {
    return this.passedParams || this.params;
  }

  agInit(params: any): void {
    this.passedParams = params;
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;

    return false;
  }

  edit(editTeamMemberModal, row: AgGridObject) {
    this.updateSent = false;
    this.modalService.open(editTeamMemberModal, { centered: true, windowClass: 'modal650px' });

    this.modalModel = {
      id: row.id + 1,
      teamMemberId: row.teamMemberId,
      firstName: row.firstName,
      lastName: row.lastName,
      fullName: row.firstName + ' ' + row.lastName,
      accessCode: row.accessCode,
      emailAddress: row.emailAddress,
      status: row.status,
      selected: row.selected,
      isTeamLeader: row.isTeamLeader,
    };
  }

  submitForm(form: NgForm) {
    if (form.valid) {
      this.updateSent = true;
      this.updateResponse = '';

      // Need to create local variable because if we try to use form.values in the callback, it comes back as Undefined
      const formValues = form.value;

      const rowNode = this.effectiveParams.api.getRowNode((formValues.id - 1).toString());

      if (rowNode.data.emailAddress === formValues.emailAddress && rowNode.data.fullName === formValues.firstName + ' ' + formValues.lastName) {
        this.updateResponse = 'Team member information has not changed';
      } else {
        this.hideUpdateSpinner = false;
        this.http.post('/api/teams/member/update', formValues).subscribe(
          () => {
            this.hideUpdateSpinner = true;
            this.updateResponse = 'Team member has been updated';
            this._manageTeamService.rebindGrid(rowNode.data.isTeamLeader);

            rowNode.setDataValue('emailAddress', formValues.emailAddress);
            rowNode.setDataValue('fullName', formValues.firstName + ' ' + formValues.lastName);
            rowNode.setDataValue('firstName', formValues.firstName);
            rowNode.setDataValue('lastName', formValues.lastName);
          },
          (err) => {
            this._applicationInsightsService.logException(err);
            let errorMessage = err.status === 409 ? err.error.message : 'We apologize, an error occurred.  Please try again';
            this.updateResponse = errorMessage;
            this.hideUpdateSpinner = true;
          },
        );
      }
    }
  }
}
